<app-button-advanced
  class="action-button"
  [action]="eraserAction"
  [active]="(isEraserActive$ | async)!"
  (clickedByCorner)="
    stateManagerProjectService.currentStateOfToolMenu = 'ERASER';
    menuTrigger.openMenu()
  "
  [displayCorner]="settings.displayCorner"
  matTooltip="{{ 'viewer.Tools.Eraser' | translate }}"
  [matTooltipPosition]="'left'"
  [hotButton]="settings.displayHotKey ? 'E' : ''"
  [isMenuOpened]="menuTrigger.menuOpen"
  [matTooltipDisabled]="settings.disableTooltip || (isDisabled$ | async)"
  (contextmenu)="onEraserActionContextMenu($event)"
></app-button-advanced>

<span
  #menuTrigger="matMenuTrigger"
  class="hidden-menu-trigger"
  [matMenuTriggerFor]="(isDisabled$ | async) ? null : pointerSettingsMenu"
>
</span>
<mat-menu
  #pointerSettingsMenu
  [xPosition]="settings.menuPosition.x"
  [yPosition]="settings.menuPosition.y"
  [hasBackdrop]="!settings.hideMenuBackdrop"
  class="tool-menu {{ settings.menuClass ?? '' }}"
  (closed)="updateComponent()"
>
  <app-pointer-settings
    [class]="settings.menuItemClass ?? ''"
    toolName="Eraser"
    [shape]="eraserSettings.shape"
    [size]="eraserSettings.size"
    [isToolActive]="(isEraserActive$ | async)!"
    [useHotKeys]="useHotKeys"
    (sizeChange)="onSizeChanged($event)"
    (shapeChange)="onShapeChanged($event)"
  ></app-pointer-settings>
</mat-menu>
